module.exports = __webpack_public_path__ + "static/media/new_file_light_icn.d6882b72.png";